import { SvgIcon, SvgIconProps } from '@mui/material';

export const CrossPlusIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    sx={{ fill: 'none' }}
    {...props}
  >
    <path
      d="M10.5 2.00021V20.0002"
      strokeWidth="2.48659"
      strokeLinecap="round"
    />
    <path
      d="M1.5 11.0002L19.5 11.0002"
      strokeWidth="2.48659"
      strokeLinecap="round"
    />
  </SvgIcon>
);
